/*----------------------------------
- CATALOG (SSOT): THE COMPANY'S SOCIAL ACCOUNTS
----------------------------------*/

/**
 * The company accounts the world footer's bottom bar links (the mock's `.soc`, docs/mockups/website-page-template.html).
 * GitHub is not here: its link is `links.github`, the lists repository the rest of the site already reads.
 *
 * @docs docs/features/website-navigation-shell
 * @rule The X account is @UniqueDomains_, the one Product's rail card follows (`RAIL_FOLLOW_X_CARD` in
 *       apps/product/client/catalogs/app/shell/socialCatalog.ts). The two apps cannot import each other, so a handle
 *       change edits both catalogs. The old footer linked a retired handle.
 */

/*----------------------------------
- DEPENDANCES
----------------------------------*/

import type { SpriteIconName } from '@/client/components/ui/icon/Icon';

/*----------------------------------
- TYPES
----------------------------------*/

export type WebsiteSocialLink = {
    /** The accessible name of the round button (the icon carries no text). */
    label: string;
    href: string;
    icon: SpriteIconName;
};

/*----------------------------------
- CATALOG (SSOT)
----------------------------------*/

export const WEBSITE_SOCIAL_LINKS: readonly WebsiteSocialLink[] = [
    { label: 'LinkedIn', href: 'https://www.linkedin.com/company/uniquedomains', icon: 'linkedin' },
    { label: 'Instagram', href: 'https://www.instagram.com/kai.etan/', icon: 'instagram' },
    { label: 'X', href: 'https://x.com/UniqueDomains_', icon: 'x' },
];
